<template>
  <div class="hero">
    <div class="hero-image-wrapper">
      <img
        :src="heroImage"
        class="hero-image"
      >
      <img
        :src="require(`@images/icon/ico_rank${hero.rank}-m.png`)"
        class="icon-rank"
        height="79"
        width="78"
      >
    </div>
    <div class="description">
      <span class="hero-name" v-html="$t(`${hero.heroId}`, null, 'localeCharacter')" />
      <p class="series-name" :class="{'-small': isSpanish}" v-html="seriesNames" />
      <span class="vote-count" v-html="$t('text011', {votes: count(hero.voteCount)}, 'localeResult')" />
    </div>
  </div>
</template>

<script>
import { localeFigure } from '@constants'
import localeResult from '@locales/result'
import localeCharacter from '@locales/character'
import localeSeries from '@locales/series'

export default {
  name: 'hero-stand',
  $messages: { localeResult, localeCharacter, localeSeries },
  props: {
    hero: {
      type: Object,
      required: true,
    }
  },
  computed: {
    seriesNames(){
      const seriesNames = this.hero.seriesIds.map(s => {
        return this.$t(`game${s.id}.title`, null, 'localeSeries')
      }).filter(s => s)
      return seriesNames.join('<br>')
    },
    heroImage(){
      let res = null
      switch (this.hero.heroId) {
        case '115006':
          //male1
          res = '4c0ac0cbfed43619b45f86f9ddf9f632'
          break
        case '115007':
          //male2
          res = 'a4ac557ae72c9e625b04f32000050fec'
          break
        case '115005':
          //female1
          res = '91fcea37e1e79fa65d38ad2cd2de7712'
          break
        case '115025':
          //female2
          res = '8448e0b50b4f679723ac5ab54ba81ece'
      }
      return res ? require(`@images/result/heroes/${res}.png`) : null
    },
    isSpanish() {
      if (!this.$route.params.lang) return false
      return /^es-/g.test(this.$route.params.lang)
    }
  },
  methods: {
    count(count) {
      return localeFigure(count, this.$route.params.lang)
    }
  }
}
</script>

<style lang="scss" scoped>
.hero {
  width: 50%;
  position: relative;
  height: 460px;
}
.hero-image-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
}
.hero-image {
  position: absolute;
  bottom: 100px;
  left: 50%;
  transform: translateX(-40%);
}
.icon-rank {
  position: absolute;
  top: -20px;
  left: 20px;
}
.description {
  background: linear-gradient(to right, rgba(0,0,0,0) 0%,rgba(0,0,0,0) 1%,rgba(0,0,0,1) 15%,rgba(0,0,0,1) 50%,rgba(0,0,0,1) 85%,rgba(0,0,0,0) 100%);
  text-align: center;
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: 0;
  left: 20px;
  width: 100%;
  .hero-name {
    font-size: $fs-base * 1.4;
  }
  .series-name {
    color: #878787;
    font-size: $fs-base * 0.9;
    &.-small {
      font-size: $fs-base * 0.8;
    }
  }
  .vote-count {
    color: #878787;
    font-size: $fs-base * 1.2;
  }
}
</style>
